var chunkMapping = {
	"0": [
		4648
	],
	"74": [
		5054
	],
	"150": [
		5130
	],
	"151": [
		5131
	],
	"154": [
		5134
	],
	"155": [
		5135
	],
	"156": [
		5136
	],
	"157": [
		5137
	],
	"158": [
		5138
	],
	"159": [
		5139
	],
	"160": [
		5140
	],
	"161": [
		5141
	],
	"162": [
		5142
	],
	"163": [
		5143
	],
	"164": [
		5144
	],
	"165": [
		5145
	],
	"166": [
		5146
	],
	"167": [
		5147
	],
	"168": [
		5148
	],
	"169": [
		5149
	],
	"170": [
		5150
	]
};
var idToExternalAndNameMapping = {
	"4648": [
		"default",
		"./Containers",
		3796
	],
	"5054": [
		"default",
		"./OrderlessInvoices",
		3796
	],
	"5130": [
		"default",
		"./AsyncEventTracker",
		3796
	],
	"5131": [
		"default",
		"./HostWrapper",
		3796
	],
	"5134": [
		"default",
		"./CheckoutV3",
		3796
	],
	"5135": [
		"default",
		"./CheckoutConfirmation",
		3796
	],
	"5136": [
		"default",
		"./ContactCreditCards",
		3796
	],
	"5137": [
		"default",
		"./AuditDialog",
		3796
	],
	"5138": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3796
	],
	"5139": [
		"default",
		"./InvoiceDialog",
		3796
	],
	"5140": [
		"default",
		"./PaymentDueModal",
		3796
	],
	"5141": [
		"default",
		"./PaymentModal",
		3796
	],
	"5142": [
		"default",
		"./PaymentHistory",
		3796
	],
	"5143": [
		"default",
		"./PaymentConfigurations",
		3796
	],
	"5144": [
		"default",
		"./PaymentPreferences",
		3796
	],
	"5145": [
		"default",
		"./ManagePaymentProcessing",
		3796
	],
	"5146": [
		"default",
		"./MobilePaymentsWrapper",
		3796
	],
	"5147": [
		"default",
		"./Challenge",
		3796
	],
	"5148": [
		"default",
		"./ManagePaymentMethods",
		3796
	],
	"5149": [
		"default",
		"./LightspeedReports",
		3796
	],
	"5150": [
		"default",
		"./ShippingPromotionsListContainer",
		3796
	]
};
var idToRemoteMap = {
	"4648": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5054": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5130": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5134": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5145": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5146": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5147": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5148": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5149": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5150": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}